/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');

var tmplCOCEntityView = require('../templates/COCEntityView.hbs');
var COCEntityFormView = require('./COCEntityFormView');
require('../styles/COCEntityView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEntityView,

  className: 'coc-entity-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    entityFormContainer: '.entity-form-container',
    entityActionDropDown: '.entity-action-dropdown'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    entityFormContainer: '@ui.entityFormContainer',
    entityActionDropDown: '@ui.entityActionDropDown'
  },

  events: {},

  onBeforeShow: function() {
    var entity = this.model.get('entity');
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            text: entity.name
          }
        ]
      })
    );

    var dropDownOptions = [
      {
        text: 'Edit Entity',
        link: '#coc/entity/' + entity.id + '/edit'
      }
    ];

    this.showChildView(
      'entityActionDropDown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Actions',
          options: dropDownOptions
        })
      })
    );

    this.entityForm = new COCEntityFormView({
      model: new Backbone.Model({
        isReadOnly: true,
        viewMode: 'view',
        entityTypes: this.model.get('entityTypes'),
        organizationTypes: this.model.get('organizationTypes'),
        entity: entity
      })
    });
    this.showChildView('entityFormContainer', this.entityForm);
  }
});
